module.exports = __webpack_public_path__ + "img/jne_login.e62a955b.svg";